import { MODULE_NAME as BILLING_MODULE } from 'modules/billing-and-payments/config/routes';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { columnDefs } from './columnDefinitions';
import { INVOICES_REPORT_ID } from './invoicesReportId';
import { defaultColumns } from './reportPresets';

export const invoicesReportConfig = {
    id: INVOICES_REPORT_ID,
    label: 'Invoices',
    permissions: [REPORT_PERMISSION.BUDGET_MANAGEMENT_VIEW, REPORT_PERMISSION.PAYMENT_INVOICES_VIEW],
    module: BILLING_MODULE,
    endpoint: 'billing/invoices',
    rowIdField: FIELDS.INVOICE_ID.field,
    searchField: FIELDS.INVOICE_NAME.field,
    searchPlaceholderMsgId: 'billingAndPayments.reports.byInvoiceName.search.placeHolder',
    columnsDef: columnDefs,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    footerColumnDef: [],
    autoFitColumnsToScreen: true,
};
